export default __webpack_public_path__ + "static/media/1-2-2.5cdec73f.jpg";